export default __webpack_public_path__ + "media/images/banner/banner-25-65e2d56ebdf0d6ca0051100d47f3c79b.jpg";